"use client";

import { useState, useEffect, forwardRef } from "react";
import { isInViewport } from "util/helper/helper";

interface IProps {
  children: Element;
  offset?: number;
  visibleIfRefIsInViewPort?: boolean;
  onlyOneTime?: boolean;
}

const OnScrollComponent = forwardRef((props: IProps, ref: any) => {
  const {
    children, offset = 0, visibleIfRefIsInViewPort = false, onlyOneTime = false,
  } = props;

  const [showComponent, setShowComponent] = useState(false);
  const [isRenderedFirstTime, setIsRenderedFirstTime] = useState(false);

  function listenScrollEvent() {
    const el = ref.current;
    const conditionForViewPort = visibleIfRefIsInViewPort ? isInViewport(el, offset) : !isInViewport(el, offset);

    if (conditionForViewPort) {
      setIsRenderedFirstTime(true);
    }
    setShowComponent(!!conditionForViewPort);
  }

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  if ((onlyOneTime && isRenderedFirstTime) || showComponent) {
    return children;
  }
  return null;
});

OnScrollComponent.displayName = "OnScrollComponent";
export default OnScrollComponent;
